/**
 * Removes properties with nullish or "falsy" values from an object.
 *
 * Nullish and "falsy" values include:
 * - `null`
 * - `undefined`
 * - Empty strings (`''`)
 * - Zero (`0`)
 * - `false`
 * - Empty arrays (`[]`)
 */
export function removeFalsyValues<T extends object>(obj: T): T {
  return Object.fromEntries(
    Object.entries(obj).filter(
      ([_, value]) =>
        value !== null &&
        value !== undefined &&
        value !== '' &&
        value !== 0 &&
        value !== false &&
        (Array.isArray(value) ? value.length > 0 : true),
    ),
  ) as T
}

/**
 * Utility function for exhaustive checks in TypeScript.
 *
 * Use this function to ensure all cases of a discriminated union are handled.
 * If an unhandled case arises, this function throws an error.
 */
export function assertNever(value: never): never {
  throw new Error(`Unexpected value: ${value}`)
}

/** Remove a trailing slash from a URL string */
export function removeTrailingSlash(url: URL | string) {
  return url.toString().replace(/\/$/, '')
}
